var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.errors),expression:"errors"}],staticClass:"check-box f-column",class:{'checkbox-checked': _vm.value},on:{"click":_vm.emit}},[_vm._t("default"),_c('div',{staticClass:"validation-output mt-1"},[_vm._t("validations")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }